<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/mirror_icon.png" alt="거울 아이콘">
        <div class="text_box">
            <span>스마트 거울</span>
        </div>
    </div>
</div>